import { createWebHistory, createRouter } from "vue-router";
import { useGlobalStore, useUserStore } from "@/stores";

import LoginView from "@/views/LoginView";
import DashboardView from "@/views/DashboardView";
import BeneficiaryAddSimpleView from "@/views/BeneficiaryAddSimpleView";
import BeneficiaryEditView from "@/views/BeneficiaryEditView";
import BeneficiaryOverview from "@/views/BeneficiaryOverview";
import BeneficiaryDashboard from "@/views/BeneficiaryDashboard";
import AcademyDashboard from "@/views/AcademyDashboard";
import AcademyOverview from "@/views/AcademyOverview";
import CourseAddView from "@/views/CourseAddView.vue";
import CourseEditView from "@/views/CourseEditView.vue";
import CompanyOverview from "@/views/CompanyOverview.vue";
import CompanyAddView from "@/views/CompanyAddView.vue";
import CompanyEditView from "@/views/CompanyEditView.vue";
import JobPositionOverview from "@/views/JobPositionOverview.vue";
import JobPositionAddView from "@/views/JobPositionAddView.vue";
import JobPositionEditView from "@/views/JobPositionEditView.vue";
import EmployabilityOverview from "@/views/EmployabilityOverview.vue";
import EmployabilityServiceOverview from "@/views/EmployabilityServiceOverview.vue";
import EmployabilityEditView from "@/views/EmployabilityEditView.vue";
import EmployabilityAddView from "@/views/EmployabilityAddView.vue";
import LivelihoodOverview from "@/views/LivelihoodOverview.vue";
import LivelihoodEditView from "@/views/LivelihoodEditView.vue";
import LivelihoodAddView from "@/views/LivelihoodAddView.vue";
import CourseEvaluationAdd from "@/views/CourseEvaluationAdd.vue";
import UserSettingsView from "@/views/UserSettingsView.vue";
import StudentEvaluationAdd from "@/views/StudentEvaluationAdd.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import EmployabilityDashboard from "@/views/EmployabilityDashboard.vue";
import EvaluationsDashboard from "@/views/EvaluationsDashboard.vue";
import BeneficiaryView from "@/views/BeneficiaryView.vue";
import CourseView from "@/views/CourseView.vue";
import LivelihoodView from "@/views/LivelihoodView.vue";
import EmployabilityView from "@/views/EmployabilityView.vue";
import CompanyView from "@/views/CompanyView.vue";
import JobPositionView from "@/views/JobPositionView.vue";
import CourseEvaluationView from "@/views/CourseEvaluationView.vue";
import StudentEvaluationView from "@/views/StudentEvaluationView.vue";
import NotificationsView from "@/views/NotificationsView.vue";
import ProjectReports from "@/views/ProjectReports.vue";
import AdminView from "@/views/AdminView.vue";
import AddUserView from "@/views/AddUserView.vue";
import AdminEditLists from "@/views/AdminEditLists.vue";
import EditUserView from "@/views/EditUserView.vue";
import LivelihoodQuestionnaire from "@/views/LivelihoodQuestionnaire.vue";
import LivelihoodQuestionnaireOverview from "@/views/LivelihoodQuestionnaireOverview.vue";
import LivelihoodQuestionnaireEditView from "@/views/LivelihoodQuestionnaireEditView.vue";

const routes = [
  {
    path: "/",
    component: LoginView,
    beforeEnter: (to, from, next) => {
      const userStore = useUserStore();
      if (userStore.authenticated) {
        next("/dashboard");
      } else {
        next();
      }
    },
  },
  {
    path: "/dashboard",
    component: DashboardView,
    meta: { requiresAuth: true },
  },
  {
    path: "/reset-password",
    component: ResetPasswordView,
    meta: { requiresAuth: false },
    beforeEnter: (to, from, next) => {
      const userStore = useUserStore();
      const globalStore = useGlobalStore();
      const urlParams = new URLSearchParams(window.location.search);
      const accessToken = urlParams.get("accessToken");
      const refreshToken = urlParams.get("refreshToken");
      if (
        (accessToken != null && accessToken != "null") ||
        (refreshToken != null && refreshToken != "null")
      ) {
        userStore.setTokens({ accessToken, refreshToken });
        userStore.authenticated = false;
      }
      if (
        urlParams.get("key") == null ||
        urlParams.get("key") == "" ||
        urlParams.get("key") == undefined
      ) {
        globalStore.showSnackbar({
          show: true,
          text: "Reset link is invalid",
          timeout: 3000,
          type: "error",
          position: "top",
        });
        next("/");
      }
      next();
    },
  },
  {
    path: "/user-settings",
    component: UserSettingsView,
    meta: { requiresAuth: true },
  },

  {
    path: "/notifications/whats-new",
    component: NotificationsView,
    meta: { requiresAuth: true },
  },

  {
    path: "/project/reports",
    component: ProjectReports,
    meta: { requiresAuth: true },
  },

  {
    path: "/beneficiary",
    meta: { requiresAuth: true },
    children: [
      /*
      {
        path: "dashboard",
        meta: { requiresAuth: true },
        component: BeneficiaryDashboard,
      },
      {
        path: "overview",
        meta: { requiresAuth: true },
        component: BeneficiaryOverview,
      },
      {
        path: "add-simple",
        meta: { requiresAuth: true },
        component: BeneficiaryAddSimpleView,
      },
      {
        path: "edit/:id",
        meta: { requiresAuth: true },
        component: BeneficiaryEditView,
      },
      {
        name: "BeneficiaryView",
        path: "view/:id",
        meta: { requiresAuth: true },
        component: BeneficiaryView,
      },
    */
      { path: "dashboard", meta: { requiresAuth: true }, component: BeneficiaryDashboard },
      { path: "overview", redirect: "/beneficiary/intake/overview" },
      { path: "add-simple", redirect: "/beneficiary/intake/create" },
      { path: "edit/:id", redirect: (to) => `/beneficiary/intake/edit/${to.params.id}` },
      { path: "view/:id", redirect: (to) => `/beneficiary/intake/view/${to.params.id}` },
    ],
  },
  {
    path: "/employability",
    meta: { requiresAuth: true },
    children: [
      {
        path: "overview",
        meta: { requiresAuth: true },
        component: EmployabilityOverview,
      },
      {
        path: "service-overview",
        meta: { requiresAuth: true },
        component: EmployabilityServiceOverview,
      },
      {
        path: "dashboard",
        meta: { requiresAuth: true },
        component: EmployabilityDashboard,
      },
      {
        path: "add",
        meta: { requiresAuth: true },
        component: EmployabilityAddView,
      },
      {
        path: "edit/:id",
        meta: { requiresAuth: true },
        component: EmployabilityEditView,
      },
      {
        path: "view/:id",
        meta: { requiresAuth: true },
        component: EmployabilityView,
      },
    ],
  },
  {
    path: "/livelihood",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        meta: { requiresAuth: true },
        component: BeneficiaryDashboard,
      },
      // {
      //   path: "overview",
      //   meta: { requiresAuth: true },
      //   component: LivelihoodOverview,
      // },
      // {
      //   path: "add",
      //   meta: { requiresAuth: true },
      //   component: LivelihoodAddView,
      // },
      {
        path: "questionnaire",
        meta: { requiresAuth: true },
        component: LivelihoodQuestionnaire,
      },
      {
        path: "questionnaire/edit/:id",
        meta: { requiresAuth: true },
        component: LivelihoodQuestionnaireEditView,
      },
      {
        path: "questionnaire/overview",
        meta: { requiresAuth: true },
        component: LivelihoodQuestionnaireOverview,
      },
      {
        path: "edit/:id",
        meta: { requiresAuth: true },
        component: LivelihoodEditView,
      },
      {
        path: "view/:id",
        meta: { requiresAuth: true },
        component: LivelihoodView,
      },
    ],
  },
  {
    path: "/academy",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        meta: { requiresAuth: true },
        component: AcademyDashboard,
      },
      {
        path: "evaluations/dashboard",
        meta: { requiresAuth: true },
        component: EvaluationsDashboard,
      },
      {
        path: "overview",
        meta: { requiresAuth: true },
        component: AcademyOverview,
      },
      {
        path: "add",
        meta: { requiresAuth: true },
        component: CourseAddView,
      },
      {
        path: "edit/:id",
        meta: { requiresAuth: true },
        component: CourseEditView,
      },
      {
        path: "view/:id",
        meta: { requiresAuth: true },
        component: CourseView,
      },
      {
        name: "tutor-evaluation",
        path: "evaluation/add-course",
        meta: { requiresAuth: true },
        component: CourseEvaluationAdd,
      },
      {
        name: "student-evaluation",
        path: "evaluation/add-student",
        meta: { requiresAuth: true },
        component: StudentEvaluationAdd,
      },
      {
        name: "tutor-evaluation-view",
        path: "evaluation/course/view/:id",
        meta: { requiresAuth: true },
        component: CourseEvaluationView,
      },
      {
        name: "student-evaluation-view",
        path: "evaluation/student/view/:id",
        meta: { requiresAuth: true },
        component: StudentEvaluationView,
      },
    ],
  },
  {
    path: "/company",
    meta: { requiresAuth: true },
    children: [
      {
        path: "dashboard",
        meta: { requiresAuth: true },
        component: BeneficiaryDashboard,
      },
      {
        path: "overview",
        meta: { requiresAuth: true },
        component: CompanyOverview,
      },
      {
        path: "add",
        meta: { requiresAuth: true },
        component: CompanyAddView,
      },
      {
        path: "job-position/overview",
        meta: { requiresAuth: true },
        component: JobPositionOverview,
      },
      {
        path: "job-position/add",
        meta: { requiresAuth: true },
        component: JobPositionAddView,
      },
      {
        path: "edit/:id",
        meta: { requiresAuth: true },
        component: CompanyEditView,
      },
      {
        path: "view/:id",
        meta: { requiresAuth: true },
        component: CompanyView,
      },
      {
        path: "job-position/edit/:id",
        meta: { requiresAuth: true },
        component: JobPositionEditView,
      },
      {
        path: "job-position/view/:id",
        meta: { requiresAuth: true },
        component: JobPositionView,
      },
    ],
  },
  {
    path: "/courses/:id",
    redirect: (to) => {
      const { id } = to.params;
      return `/academy/view/${id}`;
    },
  },
  {
    path: "/beneficiaries/:id",
    redirect: (to) => `/beneficiary/intake/view/${to.params.id}`,
  },
  {
    path: "/companies/:id",
    redirect: (to) => {
      const { id } = to.params;
      return `/company/view/${id}`;
    },
  },
  {
    path: "/auth/callback", // 🔹 Handle token extraction but do NOT render a component
    component: {
      template: "<div></div>",
      beforeRouteEnter: (to, from, next) => {
        const userStore = useUserStore();
        const urlParams = new URLSearchParams(window.location.search);
        const accessToken = urlParams.get("accessToken");
        const refreshToken = urlParams.get("refreshToken");

        if (
          (accessToken != null && accessToken != "null") ||
          (refreshToken != null && refreshToken != "null")
        ) {
          userStore.setTokens({ accessToken, refreshToken });

          next("/dashboard");
        } else {
          next("/");
        }
      },
    },
  },
  {
    path: "/admin",
    meta: { requiresAuth: true },
    children: [
      {
        path: "/admin/user/overview",
        component: AdminView,
        beforeEnter: (to, from, next) => {
          const roles = JSON.parse(localStorage.getItem("roles") || "[]");
          const isAdmin = roles.some((role) => role.name == "ROLE_ADMIN");
          if (isAdmin) {
            next();
          } else {
            next("/");
          }
        },
      },
      {
        path: "/admin/user/add",
        component: AddUserView,
        beforeEnter: (to, from, next) => {
          const roles = JSON.parse(localStorage.getItem("roles") || "[]");
          const isAdmin = roles.some((role) => role.name == "ROLE_ADMIN");
          if (isAdmin) {
            next();
          } else {
            next("/");
          }
        },
      },
      {
        path: "/admin/user/edit/:id",
        component: EditUserView,
        beforeEnter: (to, from, next) => {
          const roles = JSON.parse(localStorage.getItem("roles") || "[]");
          const isAdmin = roles.some((role) => role.name === "ROLE_ADMIN");
          if (isAdmin) {
            next();
          } else {
            next("/");
          }
        },
      },

      {
        path: "/admin/edit/lists",
        component: AdminEditLists,
        beforeEnter: (to, from, next) => {
          const roles = JSON.parse(localStorage.getItem("roles") || "[]");
          const isAdmin = roles.some((role) => role.name == "ROLE_ADMIN");
          if (isAdmin) {
            next();
          } else {
            next("/");
          }
        },
      },
    ],
  },
  {
    path: "/beneficiary/intake",
    meta: { requiresAuth: true },
    children: [
      {
        name: "BeneficiaryIntakeCreate",
        path: "create",
        meta: { requiresAuth: true },
        component: () =>
          import("@/views/BeneficiaryIntakeRegistrationView.vue"),
      },
      {
        name: "BeneficiaryIntakeEdit",
        path: "edit/:id",
        meta: { requiresAuth: true },
        component: () => import("@/views/BeneficiaryIntakeEditView.vue"),
      },
      {
        name: "BeneficiaryIntakeView",
        path: "view/:id",
        meta: { requiresAuth: true },
        component: () => import("@/views/BeneficiaryIntakeView.vue"),
      },
      {
        name: "BeneficiaryIntakeOverview",
        path: "overview",
        meta: { requiresAuth: true },
        component: () => import("@/views/BeneficiaryIntakeOverview.vue"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();
  await userStore.autoLogin();
  if (
    to.meta.requiresAuth &&
    (userStore.accessToken === null || userStore.accessToken === "null")
  ) {
    next("/");
  } else {
    next();
  }
});

export default router;
